import { createContext } from "react";

export interface BrowserProctoringFunctionsContext {
  stopBrowserProctoring: () => void;
}

export const BrowserProctoringFunctionsContext =
  createContext<BrowserProctoringFunctionsContext | null>(null);
